import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import './admin-reset.css'
import './AdminLogin.css'
import { API_URL } from '../api/base'

export const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [formErrors, setFormErrors] = useState<Record<string, string>>({})
  const navigate = useNavigate()

  // Проверяем, залогинен ли пользователь при загрузке
  useEffect(() => {
    const token = localStorage.getItem('admin_token')
    const user = localStorage.getItem('admin_user')
    if (token && user) {
      navigate('/admin/donations')
    }
  }, [navigate])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    // Валидация
    const errors: Record<string, string> = {}
    if (!email.trim()) errors.email = 'Обязательное поле'
    if (!password.trim()) errors.password = 'Обязательное поле'

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors)
      setLoading(false)
      return
    }

    try {
      const { data } = await axios.post(`${API_URL}/api/admin/login`, {
        email,
        password
      })

      localStorage.setItem('admin_token', data.token)
      localStorage.setItem('admin_user', JSON.stringify(data.user))

      navigate('/admin/donations')
    } catch (err: unknown) {
      const errorMessage = err instanceof Error && 'response' in err
        ? ((err as any).response?.data?.message || 'Ошибка входа')
        : 'Ошибка входа'
      setError(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-header">
          <h1>Жашыл дем</h1>
          <p>Админ-панель</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && <div className="login-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value)
                if (formErrors.email) {
                  setFormErrors({ ...formErrors, email: '' })
                }
              }}
              autoComplete="email"
              className={formErrors.email ? 'border-red-500' : ''}
            />
            {formErrors.email && (
              <div className="field-error">
                {formErrors.email}
              </div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="password">Пароль</label>
            <input
              id="password"
              type="password"
              name="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value)
                if (formErrors.password) {
                  setFormErrors({ ...formErrors, password: '' })
                }
              }}
              autoComplete="current-password"
              className={formErrors.password ? 'border-red-500' : ''}
            />
            {formErrors.password && (
              <div className="field-error">
                {formErrors.password}
              </div>
            )}
          </div>

          <button type="submit" disabled={loading} className="login-button">
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  )
}
